import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { SubPageLayout } from '../sub-page-layout';
import { EntityDetailsContainer } from '../components/entity-details.container';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const EntityDetail: React.FC<any> = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Entity - Detail</title>
      </Helmet>
      <SubPageLayout
        header={
          <PageHeader title={<Typography.Title style={{ fontSize: '30px', marginTop: '12px' }}>Entity Details</Typography.Title>} onBack={() => navigate(-1)}></PageHeader>
        }
      >
        <EntityDetailsContainer />
      </SubPageLayout>
    </>
  );
};
